import { useCallback, useLayoutEffect, useRef } from 'react';

/**
 * Devuelve el foco a quien abrió la capa (diálogo u hoja) al cerrarla, aunque se haya abierto desde código
 * y no con un <Trigger> de Radix. Úsalo en `onCloseAutoFocus` del contenido.
 */
export function useRestoreFocus(open: boolean | undefined) {
  const origin = useRef<HTMLElement | null>(null);

  useLayoutEffect(() => {
    // Se captura antes de que Radix mueva el foco al interior (los efectos del padre corren primero en layout).
    if (open)
      origin.current =
        document.activeElement instanceof HTMLElement ? document.activeElement : null;
  }, [open]);

  return useCallback((event: Event) => {
    const element = origin.current;
    if (element?.isConnected) {
      event.preventDefault();
      element.focus();
    }
    origin.current = null;
  }, []);
}
